import React from "react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const educationData = {
  badge: "SmartClass AI",
  title: "Education AI Platform",
  industry: "Education",
  tagline: "Personalized learning at scale with AI tutors, smart assessments, and real-time analytics.",
  image: "https://images.pexels.com/photos/31656148/pexels-photo-31656148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
  cta: "Explore Education Platform",
  stats: [
    { number: "40%", label: "Improved Learning Outcomes" },
    { number: "60%", label: "Reduction in Admin Work" },
    { number: "24/7", label: "AI Tutoring Availability" },
    { number: "3x", label: "Faster Assessment Grading" },
  ],
  problems: [
    {
      title: "Student Engagement Decline",
      desc: "Students disengage from traditional one-size-fits-all teaching methods, leading to poor outcomes.",
    },
    {
      title: "Learning Personalization at Scale",
      desc: "Teachers can't personalize content for 30+ students with different learning speeds and styles.",
    },
    {
      title: "Assessment Automation",
      desc: "Manual grading and assessment creation consumes enormous teacher time and bandwidth.",
    },
    {
      title: "Performance Tracking Gaps",
      desc: "Institutions lack real-time visibility into student progress and intervention triggers.",
    },
  ],
  solutions: [
    {
      title: "AI Tutors & Learning Assistants",
      desc: "Personalized AI tutors that adapt to each student's learning pace and style in real time.",
    },
    {
      title: "AI Practice Test Generators",
      desc: "Automatically generate tests, quizzes, and assignments from curriculum content.",
    },
    {
      title: "Student Analytics Dashboards",
      desc: "Real-time dashboards giving teachers and administrators actionable insights on performance.",
    },
    {
      title: "Intelligent Learning Management",
      desc: "AI-powered LMS that organizes, delivers, and adapts curriculum automatically.",
    },
  ],
  outcome:
    "Improve learning outcomes by 40% while reducing teacher workload by 60% through intelligent automation. Students receive personalized learning paths while teachers gain powerful analytics to intervene early and maximize every student's potential.",
};

const EducationPage = () => <IndustryPageTemplate data={educationData} />;

export default EducationPage;
